export default function (props: any) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none" {...props}>
            <path d="M8 16H23" stroke="#3F68E0" strokeWidth="2" />
        </svg>
    );
}
